import { inject, observer } from "mobx-react";
import { baseUrl } from "stores/main";
import ShowDocument from "components/Modals/ShowDocument";
import iconFile from "images/file.svg";
import "./files.scss";

const Files = ({
  files,

  setDocumentUrl,
  documentUrl,
  setOpenModalDocument,
  openModalDocument
}) => {
  return (
    <>
      {
        files
          ? <ul className="vacancy-files-list">
            {
              Object.values(files).map(({ id, title, file_path }) => {
                return (
                  <li key={id} className="d-flex gap-2 align-items-center">
                    <img src={iconFile} alt="файл" />
                    <p
                      onClick={() => {
                        setDocumentUrl(`${baseUrl}${file_path}`);
                        setOpenModalDocument(true);
                      }}
                    >
                      {title}
                    </p>
                  </li>
                );
              })
            }
          </ul>
          : null
      }
      {
        files && Array.isArray(files)
          ? <div>Файлы не добавлены</div>
          : null
      }
      <ShowDocument show={openModalDocument} onHide={() => setOpenModalDocument(false)} documentUrl={documentUrl} />
    </>
  );
};

export default inject(({ filesStore, }) => {
  const { setDocumentUrl, documentUrl, setOpenModalDocument, openModalDocument } = filesStore;

  return {
    setDocumentUrl,
    documentUrl,
    setOpenModalDocument,
    openModalDocument
  };
})(observer(Files));